import React from "react";
import Grid from "@material-ui/core/Grid";
import styles from "./styles";
import LoginBanner from "../../../assets/login_banner-movil.png";
import loginBanner2 from "../../../assets/grantour/wall.jpg"
import logo from "../../../assets/grantour/logo.png"
import FLogin from "../FLogin";
import { IS_DOODDO } from "../../../Constantes";
const VLogin = () => {
  const classes = styles();
  return (
    <Grid container>
      <Grid item xs={12} md={5}>
        <FLogin />
      </Grid>
      <Grid item xs={12} md={7}>
        {
          (IS_DOODDO) ?
            <div className={classes.imagenBienvenida}>
              <img
                src={LoginBanner}
                className={classes.bienvenida}
                alt="BannerLogin"
              />
            </div>
            :
            <div className={classes.imagenBienvenida}>
              <div className={classes.imagenShadow}>
                <img
                  src={loginBanner2}
                  className={classes.bienvenida2}
                  alt="BannerLogin"
                />
              </div>
              <img
                src={logo}
                className={classes.logo2}
                alt="grantour"
              />
            </div>
        }
      </Grid>
    </Grid>
  );
};
export default VLogin;
